<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="330px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h5 style="word-break: break-word">Prašymą teikia ne privatus JA asmuo!</h5>
      </v-card-title>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          title="Atšaukti"
          :loading="loading"
          @click.native.stop="cancel()"
          color="secondary"
        />
        <el-button
          title="Tęsti"
          :loading="loading"
          @click.native="continueProcess()"
          color="primary"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalDelete',
  props: {
    item: Object,
    value: Boolean,
    loading: Boolean,
    code: String,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {}
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  created() {
    this.modalloading = false
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    cancel() {
      this.closeModal()
      this.$emit('cancelPublicPerson')
    },
    continueProcess() {
      this.$emit('continuePublicPerson')
    },
  },
}
</script>
<style lang="scss" scoped></style>
